import styled from 'styled-components'

const SubTitle = styled.h2`
  margin: 0;
  font-family: ${props => props.theme.font.family.sans};
  font-size: 1.5rem;
  font-weight: ${props => props.theme.font.weight.normal};
`

export default SubTitle
